export default __webpack_public_path__ + "static/media/Check-Circle.32f62a7e.svg";